import axios from 'axios';
import axiosRetry from 'axios-retry';
import qs from 'qs';
import { loginStructure, getSetupStateStructure } from '../helpers/serviceStructures';
import { baseURL } from '../../shared/helpers/axiosConfiguration';

export const loginService = (username, password, retry) => {
    let customInstance = null;
    const serviceStructure = loginStructure(username, password);

    if (retry) {
        customInstance = axios.create();

        axiosRetry(customInstance, {
            retries: 3,
            retryDelay: () => 5000,
            retryCondition: () => true
        });
    }

    return retry ? customInstance(serviceStructure) : axios(serviceStructure);
};

export const getQuickSetupStateService = retry => {
    let customInstance = null;
    const serviceStructure = getSetupStateStructure();

    if (retry) {
        customInstance = axios.create();

        axiosRetry(customInstance, {
            retries: 3,
            retryDelay: () => 10000,
            retryCondition: () => true
        });
    }

    return retry ? customInstance(serviceStructure) : axios(serviceStructure);
};

export const initSessionVariablesService = (user, password, isAdmin, browser, version, os) => axios({
    method: 'post',
    url: `${baseURL}/control.php`,
    header: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-access-token': localStorage.getItem('token')
    },
    data: qs.stringify({
        json_response: 1,
        lang: 'es',
        user,
        password,
        profile: isAdmin ? 'operator' : 'user',
        browser,
        version,
        os,
        serveraddress: window.location.host
    })
});

export const checkUsernameService = (username, profile, language) => axios({
    method: 'get',
    url: `${baseURL}/dws/setupapi/pwdreset?username=${username}&profile=${profile}&language=${language}`,
    header: { 'Content-Type': 'application/x-www-form-urlencoded' }
});

export const resetPasswordService = (username, profile, language, code, password) => axios({
    method: 'post',
    url: `${baseURL}/dws/setupapi/pwdreset`,
    header: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: qs.stringify({
        username,
        profile,
        language,
        code,
        password
    })
});

export const getLicenceStatusService = () => axios({
    method: 'post',
    url: `${baseURL}/process/supportProc.php`,
    // url: 'http://192.168.144.245/process/supportProc.php',
    header: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: qs.stringify({ action: 'get_lic_info' })
});

export const getUnauthorizedVPNStatusService = () => axios({
    method: 'post',
    url: `${baseURL}/process/supportProc.php`,
    // url: 'http://192.168.144.245/process/supportProc.php',
    header: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: qs.stringify({ action: 'check_ip' })
});

export const connectToSupportVPNServices = language => axios({
    method: 'post',
    url: `${baseURL}/process/supportProc.php`,
    // url: 'http://192.168.144.245/process/supportProc.php',
    header: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: qs.stringify({
        action: 'connect',
        vpnname: 'denwa',
        lang: language
    })
});
